/**
 * Partner configuration for the universal import feature.
 * Maps partner IDs to their branding and display information.
 */

export interface PartnerConfig {
  id: string;
  name: string;
  logo?: string;
  primaryColor: string;
  description: string;
}

const ASSET_BASE = 'https://trademagic-assets.s3.us-west-1.amazonaws.com';

export const PARTNER_CONFIG: Record<string, PartnerConfig> = {
  tradebinder: {
    id: 'tradebinder',
    name: 'Card Binder',
    logo: `${ASSET_BASE}/assets/integrations/card-binder-logo.png`,
    primaryColor: '#3B82F6',
    description: 'Import your Card Binder collection to TradeMagic',
  },
  deckbox: {
    id: 'deckbox',
    name: 'Deckbox',
    logo: `${ASSET_BASE}/partners/deckbox-logo.png`,
    primaryColor: '#10B981',
    description: 'Import your Deckbox collection to TradeMagic',
  },
  moxfield: {
    id: 'moxfield',
    name: 'Moxfield',
    logo: `${ASSET_BASE}/partners/moxfield-logo.png`,
    primaryColor: '#8B5CF6',
    description: 'Import your Moxfield collection to TradeMagic',
  },
  tcgplayer: {
    id: 'tcgplayer',
    name: 'TCGPlayer',
    logo: `${ASSET_BASE}/partners/tcgplayer-logo.png`,
    primaryColor: '#F59E0B',
    description: 'Import your TCGPlayer collection to TradeMagic',
  },
  // Fallback for unknown partners or manual imports
  manual: {
    id: 'manual',
    name: 'Import Collection',
    primaryColor: '#DD5BEA',
    description: 'Import your card collection to TradeMagic',
  },
};

/**
 * Get partner configuration by ID, falling back to manual if not found.
 */
export function getPartnerConfig(partnerId?: string): PartnerConfig {
  if (!partnerId) return PARTNER_CONFIG.manual;
  return PARTNER_CONFIG[partnerId.toLowerCase()] || PARTNER_CONFIG.manual;
}

/**
 * Get the display name for a partner.
 */
export function getPartnerDisplayName(partnerId?: string): string {
  return getPartnerConfig(partnerId).name;
}
